import styled from '@emotion/styled';
import { rem } from 'polished';

export const ProductHeaderBannerWrapper = styled.div<{ textColor?: string }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: ${rem('300px')};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  h1,
  h2,
  p {
    color: ${({ textColor }) => textColor || '#0d0d0d'};
  }
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-direction: column;
    height: auto;
  }
`;

export const ProductHeaderBannerContent = styled.div<{
  contentAlignment?: string;
  textColor?: string;
}>`
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${({ contentAlignment }) => (contentAlignment ? contentAlignment : 'flex-start')};
  padding: ${rem('48px')} ${rem('125px')};
  background: #fff;
  text-align: left;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    order: 2;
    flex-basis: auto;
    width: 100%;
    padding: ${rem('32px')} ${rem('24px')};
  }
`;

export const ProductHeaderBannerHeading = styled.div`
  font-size: ${rem('28px')};
  font-weight: 400;
  color: #0d0d0d;
  margin-bottom: ${rem('10px')};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    font-size: ${rem('18px')};
  }
`;

export const ProductHeaderBannerTagline = styled.div`
  font-size: ${rem('20px')};
  color: #0d0d0d;
  font-weight: 400;
  margin-bottom: ${rem('12px')};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    font-size: ${rem('13px')};
  }
`;

export const ProductHeaderBannerDescription = styled.div<{
  contentAlignment?: string;
}>`
  font-size: ${rem('18px')};
  font-weight: 400;
  color: #0d0d0d;
  text-align: ${({ contentAlignment }) => (contentAlignment === 'center' ? 'center' : 'left')};
  max-width: 80%;
  margin-bottom: ${rem('24px')};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    max-width: 100%;
    margin-bottom: ${rem('16px')};
  }
`;

export const ProductHeaderBannerButtonsWrapper = styled.div`
  display: flex;
  gap: ${rem('12px')};

  @media (max-width: 480px) {
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
`;

export const ProductHeaderBannerImage = styled.div<{
  image?: string;
  mobileImage?: string;
}>`
  flex-basis: 50%;
  background: url(${({ image }) => image || ''}) center center / cover no-repeat;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    order: 1;
    flex-basis: auto;
    width: 100%;
    height: ${rem('200px')};
    background-image: ${({ mobileImage }) => (mobileImage ? `url(${mobileImage})` : 'none')};
  }
`;

export const TopWrapper = styled.div`
  position: relative;
`;
